import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IRole} from '../model/role.model';
import {environment} from '../../../../environment';

export type EntityArrayResponseType = HttpResponse<IRole>;

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private apiWsCustomer = `${environment.wsApiBaseUrl}/api/role`
  protected readonly http = inject(HttpClient);

  findAll(): Observable<EntityArrayResponseType> {
    return this.http.get<IRole>(`${this.apiWsCustomer}`, {observe: 'response'});
  }
}
